export default __webpack_public_path__ + "static/media/search.ba21de67.svg";